import { render } from "./CancerTreatmentPaths.vue?vue&type=template&id=0d8ee1c6&scoped=true"
import script from "./CancerTreatmentPaths.vue?vue&type=script&lang=js"
export * from "./CancerTreatmentPaths.vue?vue&type=script&lang=js"

import "./CancerTreatmentPaths.vue?vue&type=style&index=0&id=0d8ee1c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ee1c6"]])

export default __exports__